import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PaymentIcon from "@assets/icons/PaymentIcon";
import Loader from "@components/Loader/Loader";

const BankInfoQuote = ({
  paymentInfo,
  paymentTerms,
  setPaymentTerms,
  note,
  setNote,
  executionConditions,
  setExecutionConditions,
  isLoadingBankData,
}) => {
  const { name = "", bic = "", iban = "", rib = "" } = paymentInfo || {};
  const { t } = useTranslation();

  return (
    <div className="invoice-section">
      <Stack
        className="bank-info"
        sx={{
          backgroundColor: "#f8fbff",
          padding: "1.5rem",
          borderRadius: "16px",
          gap: "2rem",
        }}>
        {/* 🏦 Informations bancaires */}
        {paymentInfo && (
          <div className="invoice-column">
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <PaymentIcon />
              <Typography variant="h6" fontWeight="600">
                {t("invoice.payment_info") || "Informations bancaires"}
              </Typography>
            </Box>

            {isLoadingBankData ? (
              <Loader />
            ) : (
              <div className="invoice-field">
                {name && (
                  <div>
                    {t("invoice.bank_name") || "Banque"} : {name}
                  </div>
                )}
                {iban && <div>IBAN : {iban}</div>}
                {bic && <div>BIC : {bic}</div>}
                {rib && <div>RIB : {rib}</div>}
                {!name && !iban && !bic && !rib && (
                  <Typography variant="body2" color="text.secondary">
                    {t("invoice.no_bank_info") ||
                      "Aucune information bancaire disponible."}
                  </Typography>
                )}
              </div>
            )}
          </div>
        )}

        {/* 💳 Conditions de paiement */}
        <div className="invoice-column">
          <Typography variant="h6" fontWeight="600" mb={1}>
            {t("invoice.payment_terms") || "Conditions de paiement"}
          </Typography>
          <div className="invoice-field">
            <textarea
              value={paymentTerms || ""}
              className="terms-textarea"
              placeholder={
                t("invoice.enter_payment_terms") ||
                "Saisir les conditions de paiement..."
              }
              onChange={(e) => setPaymentTerms(e.target.value)}
            />
          </div>
        </div>

        {/* 📝 Note */}
        <div className="invoice-column">
          <Typography variant="h6" fontWeight="600" mb={1}>
            {t("invoice.note") || "Note"}
          </Typography>
          <div className="invoice-field">
            <textarea
              value={note || ""}
              className="notes-textarea"
              placeholder={t("invoice.enter_note") || "Saisir une note..."}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>

        {/* ⚙️ Conditions d’exécution */}
        {executionConditions !== undefined && (
          <div className="invoice-column">
            <Typography variant="h6" fontWeight="600" mb={1}>
              {t("invoice.executionConditions") || "Conditions d’exécution"}
            </Typography>
            <div className="invoice-field">
              <textarea
                value={executionConditions || ""}
                className="notes-textarea"
                placeholder={
                  t("invoice.enter_execution_conditions") ||
                  "Saisir les conditions d’exécution..."
                }
                onChange={(e) => setExecutionConditions(e.target.value)}
              />
            </div>
          </div>
        )}
      </Stack>
    </div>
  );
};

export default BankInfoQuote;
